import styles from './Initializer.module.css';
import PersonaImage from '../molecules/PersonaImage';
import messages from '../../i18n/en.json';

const formatMultiSelect = (values = []) => {
  if (!Array.isArray(values) || values.length === 0) return 'N/A';
  return values
    .map((val) =>
      val.replace(/[_-]/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
    )
    .join(', ');
};

function ReviewStep({
  personaData,
  imagePreview,
  setPersonaData,
  onSave,
  onBack,
  isSaving,
  saveError,
  currentStepNumber,
  totalSteps,
}) {
  const {
    personaId,
    personaName,
    archetype,
    summary,
    type,
    communicationStyle = {},
    personalityData = {},
  } = personaData;

  const handleSave = () => {
    onSave(personaData);
  };

  return (
    <div>
      <h3>
        Step {currentStepNumber}/{totalSteps}: Review & Create
      </h3>
      <p>
        Review the details of your new persona below. If everything looks
        correct, click "Create Persona" to save it to your account.
      </p>

      <div className={styles.reviewGrid}>
        <div className={styles.reviewSection}>
          {personaId ? (
            <PersonaImage
              personaId={personaId}
              alt={personaName}
              className={styles.reviewAvatar}
              isOwner={true}
            />
          ) : (
            imagePreview && (
              <img
                src={imagePreview}
                alt={personaName}
                className={styles.reviewAvatar}
              />
            )
          )}
          <h5>Core Identity</h5>
          <ul className={styles.reviewList}>
            <li>
              <strong>Name:</strong> {personaName || 'N/A'}
            </li>
            <li>
              <strong>Type:</strong> {messages.persona_types[type] || 'N/A'}
            </li>
            <li>
              <strong>Archetype:</strong> {archetype || 'N/A'}
            </li>
            <li>
              <strong>Summary:</strong> {summary || 'N/A'}
            </li>
          </ul>
        </div>

        <div className={styles.reviewSection}>
          <h5>Communication Style</h5>
          <ul className={styles.reviewList}>
            <li>
              <strong>Accent:</strong> {communicationStyle.accent || 'N/A'}
            </li>
            <li>
              <strong>Pacing:</strong>{' '}
              {formatMultiSelect(communicationStyle.pacing)}
            </li>
            <li>
              <strong>Humor:</strong>{' '}
              {formatMultiSelect(communicationStyle.humorStyle)}
            </li>
            <li>
              <strong>Vocabulary:</strong>{' '}
              {communicationStyle.vocabularyComplexity || 'N/A'}
            </li>
          </ul>
        </div>

        <div className={styles.reviewSection}>
          <h5>Personality Profile (Summary)</h5>
          <ul className={styles.reviewList}>
            <li>
              <strong>Openness:</strong>{' '}
              {personalityData.opennessScore || 'N/A'}/100
            </li>
            <li>
              <strong>Conscientiousness:</strong>{' '}
              {personalityData.conscientiousnessScore || 'N/A'}/100
            </li>
            <li>
              <strong>Extraversion:</strong>{' '}
              {personalityData.extraversionScore || 'N/A'}/100
            </li>
            <li>
              <strong>Agreeableness:</strong>{' '}
              {personalityData.agreeablenessScore || 'N/A'}/100
            </li>
            <li>
              <strong>Neuroticism:</strong>{' '}
              {personalityData.neuroticismScore || 'N/A'}/100
            </li>
          </ul>
        </div>
      </div>

      {type !== 'digital-me' && (
        <div className={styles.publicToggle}>
          <input
            type="checkbox"
            id="isPublic"
            name="isPublic"
            checked={personaData.isPublic || false}
            onChange={(e) =>
              setPersonaData((prev) => ({
                ...prev,
                isPublic: e.target.checked,
              }))
            }
          />
          <label htmlFor="isPublic">
            Make this persona available to the public in the Community Library.
          </label>
        </div>
      )}

      {saveError && <pre className={styles.saveError}>{saveError}</pre>}

      <div className={styles.buttonGroup}>
        <button
          onClick={onBack}
          className="action-button secondary"
          disabled={isSaving}
        >
          Back
        </button>
        <button
          onClick={handleSave}
          className="action-button primary"
          disabled={isSaving}
        >
          {isSaving ? 'Creating...' : 'Create Persona'}
        </button>
      </div>
    </div>
  );
}

export default ReviewStep;
